import React, { useState } from "react";
import SendEmailAttach from "./SendEmailAttach";
import { Button } from "../ui/button";
import Spin from "../Spin";

const AdditionalDocumentEmailModal = ({
  defaultContent,
  handleSubmit,
  setFiles,
  files,
  toggleCancel,
  handleEditorChange,
  editorState,
  mailData,
  type,
  loading
}) => {
  const [additionalDocument, setAdditionalDocument] = useState(null);
  return (
    <>
      {loading && <Spin full expand={true} />}
      {additionalDocument === null && (
        <>
          <div className="text-center">
            Do you want to attach any additional document(s) to the email?
          </div>
          <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
            <Button
              type="submit"
              data-dismiss="modal"
              onClick={() => {
                setAdditionalDocument(true);
              }}
            >
              Yes
            </Button>
            <Button
              type="Button"
              className="ml-3"
              onClick={async () => {
                setAdditionalDocument(false);
              }}
              variant="secondary"
            >
              No
            </Button>
          </div>
        </>
      )}
      {additionalDocument === true && (
        <SendEmailAttach
          handleSubmit={handleSubmit}
          setFiles={setFiles}
          files={files}
          toggleCancel={toggleCancel}
          handleEditorChange={handleEditorChange}
          editorState={editorState}
          mailData={mailData}
          type={type}
        />
      )}
      {additionalDocument === false && <>{defaultContent}</>}
    </>
  );
};

export default AdditionalDocumentEmailModal;
